import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { CampaignCriteria } from 'src/app/core/models/Campaign_Criterias';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
	providedIn: 'root',
})
export class CriteriaService {
	constructor(private dataService: OldDataService, private http: HttpClient, public utils: UtilsService,) {}

	getCampaignCriterias(campaign_id) {
		const url = `${environment.api}campaign/${campaign_id}/get_criterias`;
		return this.http.get(url);
	}

	getCampaignCriteriaStates(campaign_id: number) {
		const url = `${environment.api}campaign/${campaign_id}/get_criteria_states`;
		return this.http.get(url);
	}

	saveCampaignCriteria(criteria: CampaignCriteria, campaignId: number) {
		criteria.section_asset_size = !criteria.section_asset_size ? 0 : 1;
		criteria.section_plan_participants = !criteria.section_plan_participants ? 0 : 1;
		criteria.section_employee_size = !criteria.section_employee_size ? 0 : 1;
		criteria.section_state = !criteria.section_state ? 0 : 1;
		criteria.section_zip_code = !criteria.section_zip_code ? 0 : 1;
		criteria.campaign_id = campaignId;
		const url = `${environment.api}campaign/save_criterias`;
		const formData: any = this.utils.jsonToFormData(criteria);
		return this.http.post(url, formData);
	}

	deleteCriteriaState(payload) {
		const url = `${environment.api}campaign/delete_campaign_criteria`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	saveCriteriaState(campaignId: number, state: string, typeCustomer: string) {
		const url = `${environment.api}campaign/save_campaing_criteria_state`;
		const payload = {
			CampaignId: campaignId,
			StateCriteria: state,
			TypeCustomer: typeCustomer,
		};
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}
}
